import { useQuery } from '@tanstack/react-query';

const fetchReports = async ({ reportId }) => {
    const url = new URL(`${process.env.REACT_APP_API_URL}/powerBIReport/${reportId}`);

    const response = await fetch(url.toString(), {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    const data = await response.json();

    return data;
};

const useGetPowerBIReportById = (params) => {
    return useQuery(['powerBIReport', params], () => fetchReports(params), { enabled: !!params.reportId });
};

export default useGetPowerBIReportById;
